import { useSyncExternalStore } from "react";

const STORAGE_KEY = "zesrin.landing.brand-url";
let brandUrl = typeof window === "undefined" ? "" : window.sessionStorage.getItem(STORAGE_KEY) ?? "";
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return brandUrl;
}

export function setLandingBrandUrl(value: string) {
  brandUrl = value;
  window.sessionStorage.setItem(STORAGE_KEY, value);
  listeners.forEach((listener) => listener());
}

export function useLandingBrandUrl() {
  return useSyncExternalStore(subscribe, getSnapshot, () => "");
}
